<!-- <p>cuotas works!</p> -->
<div class="card">
  <div class="card-body align-items-center justify-content-between" style="gap: 1rem">
    <form>
      <div class="form-group">
        <label for="exampleInputEmail1">ORDEN DE PEDIDO</label>
        <input type="text" class="form-control texto" id="op" aria-describedby="# de op" placeholder="123456"
          [(ngModel)]="rem" name="rem" />
        <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
      </div>
      <button type="submit" class="btn btn-primary btn-block" (click)="consultar(rem)">
        BUSCAR
      </button>
    </form>
  </div>
</div>
<br />
<div class="card" *ngIf="data">
  <div class="card-header">
    # DE OP <strong>{{ rem }}</strong>
  </div>
  <div class="card-body">
    <blockquote class="blockquote mb-0">
      <div class="row">
        <div class="col-sm-6">
          <p>
            AGENCIA: <strong>{{ data.c_agr }}</strong>
          </p>
        </div>
        <div class="col-sm-6">
          <p>
            USUARIO: <strong>{{ data.usuario }}</strong>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <p>
            CEDULA: <strong>{{ data.n_ide }}</strong>
          </p>
        </div>
        <div class="col-sm-6">
          <p>
            TIPO DE VENTA: <strong>{{ data.tven }}</strong>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <p>
            VALOR VENTA: <strong>{{ data.vtacontado }}</strong>
          </p>
        </div>
        <div class="col-sm-6">
          <p>
            CUOTA INICIAL: <strong>{{ data.cuo_ini }}</strong>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <p>
            CAPITAL PASESALDO: <strong>{{ data.capital_pasesaldo }}</strong>
          </p>
        </div>
        <div class="col-sm-6">
          <p>
            CAPITAL A FINANCIAR: <strong>{{ data.capital }}</strong>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <p>
            PLAN: <strong>{{data.plan}}</strong>
          </p>
        </div>
        <div class="col-sm-6">
          <p>
            CUOTA ACTUAL: <strong>{{ data.valor }}</strong>
          </p>
        </div>
      </div>
    </blockquote>
    <hr>
    <!-- <coky-table class="mt-3" [data]="tableData" [pageSizeOptions]="[10,20]" [columns]="columnasTituloTabla"
      [description]="'Seleccione plan de cuota a cambiar'" (clickRow)="selectPlan($event)">
    </coky-table> -->
    <hr>
    <div class="form-group">
      <label for="cuota">NUEVO PLAN</label>
      <select class="form-control texto" id="cuota" [(ngModel)]="plan">
        <option *ngFor="let item of cuotaData" [value]="item.cuotas">
          {{ item.cuotas }} x {{ item.cuota_pagar }}
        </option>
      </select>
    </div>


    <button type="submit" class="btn btn-primary btn-block" (click)="cambiar(plan,rem)">
      CAMBIAR
    </button>
  </div>
</div>